/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Rohy',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Vyhledejte ověřená oznámení, zdroje a zásady.',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filtry',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Text placeholderu',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    'Přizpůsobte výzvu, kterou vaši čtenáři uvidí.',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Přidání panelu filtrovaného vyhledávání',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Kulatý',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Čtverec',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Barva výplně',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Barva textu',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Styly',
  'company-hub.search-extension.custom-search-config-panel.title': 'Vlastní vyhledávání',
  'company-hub.search-extension.manifest.default-placeholder-text': 'Vyhledejte ověřená oznámení, zdroje a zásady.',
  'company-hub.search-extension.manifest.macro-description': 'Přidání panelu filtrovaného vyhledávání',
  'company-hub.search-extension.manifest.macro-title': 'Vlastní vyhledávání',
  'company-hub.search-extension.more-button': 'Zobrazit další výsledky',
};
